import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { greenScaleColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return greenScaleColors[4];
  }
  if (value < 50) {
    return greenScaleColors[3];
  }
  if (value < 75) {
    return greenScaleColors[1];
  }
  return greenScaleColors[0];
};

const RecursosTransicionThird = ({ user, background, number }) => {
  const esperanza = (parseFloat(user['RECTR_ESP']) / 5) * 100;
  const resiliencia = (parseFloat(user['RECTR_RES']) / 5) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2 style={{ marginBottom: 0 }}>5.3. Esperanza</h2>
          <p className='justified'>
            En el Test Vocation Start, Esperanza significa{' '}
            <strong>
              tener expectativas positivas sobre tu capacidad para alcanzar las
              metas que te propongas en el nuevo ciclo escolar
            </strong>
            . También implica confiar en tu capacidad para ajustar y modificar
            tus estrategias cuando sea necesario para lograr esas metas.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={greenScaleColors[4]}>
              {' '}
              VERDE{' '}
            </Span>
            sugieren que tienes altos niveles de esperanza, te encuentras
            confiado en que serás capaz de alcanzar tus metas y ajustar tus
            estrategias cuando sea necesario para lograr los objetivos que te
            propongas.
          </p>
          <p className='justified'>
            Resultados en{' '}
            <Span strong color={greenScaleColors[0]}>
              GRIS
            </Span>{' '}
            sugieren menores niveles de esperanza. Para aumentar las
            expectativas positivas, puedes trabajar en relación a las metas que
            te propongas,{' '}
            <strong>
              dividir grandes objetivos en pasos más pequeños y alcanzables, que
              sean manejables y realistas, lo te ayudará a fortalecer tu
              esperanza en el éxito futuro
            </strong>
            .
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={esperanza}
                  backColor={() => getColor(100 - esperanza)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{esperanza.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>

          <br />

          <h2 style={{ marginBottom: 0 }}>5.4. Resiliencia</h2>
          <p className='justified'>
            En este test, la Resiliencia se refiere a la{' '}
            <strong>
              capacidad para enfrentar de forma exitosa los diversos
              contratiempos y desafíos que son propios de la nueva etapa escolar
            </strong>
            , como el sacarse una mala nota, recibir retroalimentación negativa
            de parte de algún docente, tener dificultades para organizar los
            tiempos de estudio o problemas para coordinarse con compañeros/as
            para hacer un trabajo.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={greenScaleColors[4]}>
              {' '}
              VERDE{' '}
            </Span>
            sugieren que tienes altos niveles de Resiliencia, por lo que eres
            capaz de sobreponerte cuando enfrentas alguna dificultad escolar,
            sin que esto afecte tu confianza en tus propias capacidades.
          </p>
          <p className='justified'>
            Resultados en{' '}
            <Span strong color={greenScaleColors[0]}>
              GRIS
            </Span>{' '}
            sugieren que para ti puede ser un poco más difícil sobreponerte
            cuando enfrentas algún contratiempo escolar.{' '}
            <strong>
              Hacer el ejercicio de enfocarse en las oportunidades de
              aprendizaje (que cosas podemos aprender) ante situaciones
              escolares difíciles te puede ayudar a aumentar tu resiliencia,
              evitando castigarte por posibles errores sino tratar de aprender
              de ellos.
            </strong>
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={resiliencia}
                  backColor={() => getColor(100 - resiliencia)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{resiliencia.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default RecursosTransicionThird;
